import { NumberDirective } from './numbers-only.directive';
import { NgModule } from '@angular/core';

@NgModule({
  exports: [NumberDirective],
  declarations: [NumberDirective],
})
export class CommonDirectiveModule { }
